/* Bloque "Combínalo con" del cajón del carrito (Hippie Chic).
   Toma el último producto agregado, pide sus complementarios (o relacionados si no tiene)
   y arma hasta 3 filas. Si algo falla, el bloque no aparece: nunca toca el carrito. */
(function () {
  if (window.__cartCombina) return;
  window.__cartCombina = true;

  var MAX = 3;
  var recsCache = {};
  // Mismo formato de plata que usa el resto de la tienda (viene de shop.money_format).
  function miles(n, sep) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
  function precio(centavos, formato) {
    var v = Math.round(Number(centavos)) / 100;
    var entero = Math.round(v);
    var f = formato || '${{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return miles(entero, ',');
        case 'amount_no_decimals_with_comma_separator': return miles(entero, '.');
        case 'amount_with_comma_separator': return miles(entero, '.') + ',' + v.toFixed(2).split('.')[1];
        case 'amount_no_decimals_with_space_separator': return miles(entero, ' ');
        case 'amount_with_apostrophe_separator': return miles(entero, "'") + '.' + v.toFixed(2).split('.')[1];
        default: return miles(entero, ',') + '.' + v.toFixed(2).split('.')[1];
      }
    });
  }

  function json(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    });
  }

  function recomendados(productId, intent) {
    var k = productId + ':' + intent;
    if (!recsCache[k]) {
      recsCache[k] = json('/recommendations/products.json?product_id=' + productId + '&limit=6&intent=' + intent)
        .then(function (d) { return d.products || []; })
        .catch(function (e) { delete recsCache[k]; throw e; });
    }
    return recsCache[k];
  }

  function buscar(cart) {
    var enCarrito = {};
    cart.items.forEach(function (i) { enCarrito[i.product_id] = true; });
    var primero = cart.items[0].product_id;
    function util(lista) {
      return lista.filter(function (p) {
        return !enCarrito[p.id] && p.available && primeraVariante(p);
      });
    }
    return recomendados(primero, 'complementary').then(function (c) {
      if (c.length) return util(c);
      return recomendados(primero, 'related').then(util);
    });
  }

  function primeraVariante(p) {
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) if (vs[i].available) return vs[i];
    return null;
  }

  function foto(p) {
    var u = p.featured_image || (p.images && p.images[0]);
    if (!u) return null;
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160&height=160&crop=center';
  }

  function el(tag, cls, texto) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (texto != null) e.textContent = texto;
    return e;
  }

  function fila(p, ph) {
    var variante = primeraVariante(p);
    var li = el('li', 'cart-combina__fila');
    var a = el('a', 'cart-combina__foto');
    a.href = p.url;
    var f = foto(p);
    if (f) {
      var img = document.createElement('img');
      img.src = f; img.alt = ''; img.loading = 'lazy'; img.width = 64; img.height = 64;
      a.appendChild(img);
    }
    var info = el('div', 'cart-combina__info');
    var n = el('a', 'cart-combina__nombre', p.title);
    n.href = p.url;
    info.appendChild(n);
    info.appendChild(el('span', 'cart-combina__precio', precio(variante.price, ph.dataset.formato)));
    var b = el('button', 'cart-combina__boton button button--secondary focus-inset', ph.dataset.agregar || 'Agregar');
    b.type = 'button';
    b.setAttribute('aria-label', (ph.dataset.agregar || 'Agregar') + ' ' + p.title);
    b.addEventListener('click', function () { agregar(b, variante, ph); });
    li.appendChild(a); li.appendChild(info); li.appendChild(b);
    return li;
  }

  function agregar(btn, variante, ph) {
    if (btn.disabled) return;
    var drawer = document.querySelector('cart-drawer');
    var textoOriginal = btn.textContent;
    btn.disabled = true;
    btn.textContent = ph.dataset.agregando || 'Agregando…';
    var body = {
      id: variante.id,
      quantity: 1,
      properties: { _origen: 'carrito' }
    };
    if (ph.closest('cart-drawer') && drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }
    fetch(((window.routes && routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (resp) {
      if (resp.status || (ph.closest('cart-drawer') && !resp.sections)) throw new Error(resp.description || 'add');
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-combina', productVariantId: variante.id });
      }
      // En la página del carrito lo más seguro es recargar: así se actualizan totales y envío.
      if (!ph.closest('cart-drawer')) { window.location.reload(); return; }
      drawer.renderContents(resp);
    }).catch(function (e) {
      console.warn('cart-combina:', e);
      btn.disabled = false;
      btn.textContent = textoOriginal;
    });
  }

  function armar(ph) {
    var mio = ph.__turno = (ph.__turno || 0) + 1;
    json('/cart.js').then(function (cart) {
      if (!cart.items.length) return [];
      return buscar(cart);
    }).then(function (lista) {
      if (mio !== ph.__turno || !ph.isConnected) return;
      lista = lista.slice(0, MAX);
      ph.textContent = '';
      if (!lista.length) return;
      ph.appendChild(el('p', 'cart-combina__titulo', ph.dataset.titulo || 'Combínalo con'));
      var ul = el('ul', 'cart-combina__lista');
      lista.forEach(function (p) { ul.appendChild(fila(p, ph)); });
      ph.appendChild(ul);
    }).catch(function (e) {
      console.warn('cart-combina:', e);
      ph.textContent = '';
    });
  }

  var programado = false;
  function revisar() {
    programado = false;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !drawer.classList.contains('active')) return;
    var ph = drawer.querySelector('[data-cart-combina]:not([data-listo])');
    if (!ph) return;
    ph.setAttribute('data-listo', '1');
    armar(ph);
  }
  function programar() {
    if (programado) return;
    programado = true;
    setTimeout(revisar, 30);
  }

  // Página del carrito (/cart): el bloque queda fuera de la parte que el tema re-renderiza,
  // así que se vuelve a armar cada vez que cambian los productos (cantidad, quitar).
  function iniciarPagina() {
    var ph = document.querySelector('cart-items [data-cart-combina]');
    if (!ph) return;
    armar(ph);
    var lista = document.getElementById('main-cart-items');
    if (!lista) return;
    var espera = null;
    new MutationObserver(function () {
      clearTimeout(espera);
      espera = setTimeout(function () { armar(ph); }, 300);
    }).observe(lista, { childList: true, subtree: true });
  }

  function iniciar() {
    iniciarPagina();
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(programar).observe(drawer, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['class']
    });
    programar();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
